<div>

    <app-common-alert-modal title="Session Expired" message="Previous Session did not end Properly, you will be logged out, Please login again" cancelBtnTitle="Cancel" actionBtnTitle="Ok"></app-common-alert-modal>


</div>